module.exports = __webpack_public_path__ + "static/media/53.52c3a4e0.png";